<template>
    <div class="mb-4">
        <div>
            <div
                class="inline-block chevron-down mx-auto"
                style="width: max(2.5vw, 2rem); height: max(2.5vw, 2rem)"
            />
        </div>
        <div class="hidden-not-touch" style="height: 7rem" />
    </div>
</template>

<script>
    export default {
        name: 'BrandBookChevronDown',
    };
</script>
